import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/components/templates/Home";
import Login from "@/components/templates/Login";
import Procedimento from "@/components/templates/Procedimento";
import Financeiro from "@/components/templates/Financeiro";
import Contas from "@/components/templates/Contas";
import Administrador from "@/components/templates/Administrador";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/procedimento",
    name: "Procedimento",
    component: Procedimento,
  },
  {
    path: "/financeiro",
    name: "Financeiro",
    component: Financeiro,
  },
  {
    path: "/contas",
    name: "Contas",
    component: Contas,
  },
  {
    path: "/administrador",
    name: "Administrador",
    component: Administrador,
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.name !== "Login" && !store.state.user.token) next({ name: "Login" });
  else next();
});

export default router;
